// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__dVyML","leftCol":"Layout_leftCol__3rC3+","section":"Layout_section__UZibO"};